"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var action_1 = require("../action");
var chain = function () {
    var actions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        actions[_i] = arguments[_i];
    }
    return action_1.default(function (_a) {
        var update = _a.update, complete = _a.complete;
        var i = 0;
        var current;
        var playCurrent = function () {
            current = actions[i].start({
                complete: function () {
                    i++;
                    (i >= actions.length) ? complete() : playCurrent();
                },
                update: update
            });
        };
        playCurrent();
        return {
            stop: function () { return current && current.stop(); }
        };
    });
};
exports.default = chain;
//# sourceMappingURL=chain.js.map


//////////////////
// WEBPACK FOOTER
// ./~/popmotion/compositors/chain.js
// module id = 42
// module chunks = 112359326995148 213534597649335 241203398517478